module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navigation'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('page-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59a8babe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 74
// module chunks = 0